import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { AuthService } from '@AppRoot/features-modules/auth/auth.service';
import { ShoppingService } from '@AppRoot/features-modules/shopping/shopping.service';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
import { cartSummary } from '@AppRoot/shared/models/common.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
})
export class MainPageComponent {
  searchOpen = false;
  showLoginPopup = false;
  cartVisible = false;
  checkoutVisible = false;
  isFeedbackVisible = false;
  cartSummary!: cartSummary;

  sidebarOpen = false;

  subscription = new Subscription();

  @Output() close = new EventEmitter<void>();

  showFooterheader = true;

  constructor(
    public globalUtilityService: GlobalUtilityService,
    private _router: Router,
    private _authService: AuthService,
    private _sharedService: SharedService,
    private _shoppingService: ShoppingService
  ) {
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const currentRoute = this._router.url;
        if (
          currentRoute.includes('/auth') ||
          currentRoute.includes('/checkout')
        ) {
          this.showFooterheader = false;
        }
      });
  }

  ngOnInit(): void {
    this.subscription.add(
      this.globalUtilityService.getFeedbackFormStatus().subscribe((status) => {
        this.isFeedbackVisible = status;
      })
    );

    this.subscription.add(
      this._sharedService.getSearchOpen().subscribe({
        next: (res) => {
          this.searchOpen = res;
        },
        error: (err) => {
          console.log(err);
        },
      })
    );

    this.subscription.add(
      this._sharedService.getCartOpen().subscribe({
        next: (res: boolean) => {
          this.cartVisible = res;
        },
        error: (err: Error) => {
          console.log(err);
        },
      })
    );

    this.getCartSummary();
  }

  getCartSummary() {
    this.subscription.add(
      this._shoppingService.getCartSummary().subscribe((res:any) => {
        this.cartSummary = res.data;
      })
    );
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  handleCheckout(checkout: boolean) {
    console.log('Checkout status:', checkout);
    this.getCartSummary();
    this.checkoutVisible = checkout;
  }

  navigateToCheckout() {
    this._router.navigate(['/checkout'], {
      queryParams: { returnUrl: this._router.url },
    });
    this.cartVisible = false;
  }

  closeFeedbackModal() {
    this.globalUtilityService.setFeedbackFormStatus(false);
  }
}
